/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react'

export const Footer = () => {
    return (
        <>
            <div className="footer">
                <h2>Get In Touch With Me</h2>
                <div className="footer-social">
                    <a id="contact-github" href="https://github.com/wdwithsuraj" target="_blank"><i className='bx bxl-github'></i></a>
                    <a id="contact-linkedin" href="https://www.linkedin.com/in/suraj-kamat-18414624a/" target="_blank"><i
                        className='bx bxl-linkedin'></i></a>
                    <a href="https://codepen.io/WDwithSuraj/pens/popular" target="_blank"><i className='bx bxl-codepen'></i></a>
                    <a href="#" ><i className='bx bxl-twitter'></i></a>
                </div>

            </div>

            <div className="footer-bottom">
                <p>Copyright © by Suraj| All Rights Reserved</p>
            </div>
        </>
    )
}
